@if (loading$ | async) {
	<mat-progress-bar mode="indeterminate" />
}

<ic-list-search-bar
	filterConfirmRedirectUrl="/home/briefing-history"
	[hasActiveFilters]="hasActiveFilters$ | async"
	[page]="pageOption"
	(searchChange)="search($event)"
/>

<ic-briefing-list class="content" [briefings]="briefingHistory$ | async" />
